var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 201,
    viewBox: "0 0 306 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_26935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.844 160.613C247.311 157.677 236.051 152.426 225.166 142.994C221.713 140.008 217.534 136.35 213.605 131.473C218.384 128.785 223.439 125.451 227.968 121.444C230.746 119.006 233.774 115.895 234.424 111.366C234.599 110.171 235.175 106.165 232.472 103.104C229.745 100.018 225.666 100.093 224.941 100.143C222.238 100.242 221.562 101.512 216.858 103.95C211.778 106.563 208.225 108.405 205.197 107.21C204.246 106.837 202.094 105.667 200.743 101.288C199.692 81.6037 183.327 65.9512 163.258 65.9512C143.19 65.9512 125.724 82.6738 125.724 103.278C126.8 127.765 134.257 144.288 139.211 153.123C139.311 153.297 139.386 153.446 139.486 153.62C150.296 172.657 167.888 189.056 176.871 197.442C177.422 197.965 177.897 198.388 178.197 198.687C178.372 198.861 178.623 199.11 178.948 199.359C179.473 199.757 180.049 200.105 180.7 200.379C184.528 201.971 188.932 200.18 190.534 196.372C191.059 195.103 191.109 193.735 191.109 193.735C191.109 193.063 191.059 192.54 191.009 192.291C190.434 188.484 190.133 186.593 190.734 185.448C191.46 184.03 193.236 183.582 193.837 183.407C196.364 182.735 198.716 183.98 202.345 185.946C203.546 186.593 203.245 186.518 205.723 187.986C208.3 189.504 210.102 190.475 212.604 191.794C217.233 194.257 218.334 194.68 219.811 194.904C221.212 195.128 222.413 195.103 223.214 195.029C224.015 194.954 225.066 194.705 226.117 194.083C228.068 192.913 228.844 191.147 229.094 190.5C229.545 189.43 229.62 188.509 229.645 188.21C229.72 187.14 229.545 186.294 229.47 185.896C228.444 181.242 227.493 179.724 227.943 177.709C227.968 177.559 228.344 175.967 229.62 174.797C232.222 172.408 236.501 173.852 242.707 174.698C245.56 175.096 249.814 175.494 255.143 175.32C255.969 175.22 258.422 174.772 260.198 172.707C260.924 171.861 261.249 171.065 261.374 170.791C263.176 166.511 260.674 161.509 255.819 160.563L255.844 160.613ZM138.26 105.817C134.432 104.224 132.63 99.8443 134.232 96.0369C135.833 92.2295 140.237 90.4378 144.066 92.0304C147.894 93.6231 149.696 98.0028 148.094 101.81C146.493 105.618 142.089 107.409 138.285 105.817H138.26ZM162.808 120.996C162.383 122.688 160.431 124.206 158.604 124.281C156.452 124.356 156.002 122.39 153.174 121.942C150.722 121.569 149.996 122.813 148.119 122.265C146.268 121.718 144.666 119.404 144.916 117.612C145.367 114.501 151.022 112.088 155.576 113.158C159.58 114.103 163.609 117.936 162.808 120.996ZM176.195 103.925C174.594 107.733 170.19 109.524 166.361 107.932C162.533 106.339 160.731 101.959 162.333 98.1521C163.934 94.3447 168.338 92.553 172.167 94.1456C175.995 95.7383 177.797 100.118 176.195 103.925Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.498 116.741C120.194 117.089 117.166 116.218 115.114 115.272C111.636 113.655 110.41 111.49 107.482 111.639C104.655 111.813 102.102 113.929 100.876 116.293C99.1496 119.702 100.376 123.186 100.951 124.778C103.253 131.248 109.309 134.409 113.188 136.449C119.518 139.759 125.799 140.879 130.854 141.128C127.901 133.463 125.749 125.326 124.498 116.741Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 119.5,
    r: 14.5,
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_759_26935)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 13,
    transform: "translate(165 125) rotate(-180)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5954 90.8249C57.4506 92.5623 69.3252 96.2177 81.4018 104.066C85.2322 106.55 89.8736 109.599 94.4345 113.891C90.0692 117.21 85.5201 121.206 81.5837 125.797C79.1671 128.593 76.5949 132.09 76.5721 136.666C76.5626 137.873 76.5424 141.92 79.6395 144.581C82.7647 147.263 86.7946 146.63 87.5066 146.481C90.1699 146.011 90.6649 144.661 94.99 141.6C99.663 138.315 102.93 136.003 106.093 136.77C107.086 137.01 109.378 137.873 111.318 142.026C115.061 161.379 133.419 174.637 153.298 171.882C173.177 169.128 188.182 150.166 185.354 129.757C180.927 105.649 171.273 90.3058 165.153 82.2354C165.03 82.0766 164.935 81.939 164.812 81.7802C151.491 64.4073 131.815 50.578 121.766 43.5042C121.149 43.0621 120.62 42.7083 120.281 42.4538C120.084 42.3053 119.802 42.0931 119.446 41.8913C118.871 41.569 118.253 41.3029 117.571 41.1211C113.56 40.069 109.443 42.4483 108.379 46.4394C108.033 47.7687 108.171 49.1312 108.171 49.1312C108.264 49.7968 108.385 50.3075 108.469 50.5472C109.561 54.2395 110.118 56.0716 109.681 57.2879C109.157 58.7925 107.458 59.4801 106.887 59.7351C104.476 60.7475 101.975 59.8379 98.1115 58.3886C96.8329 57.9126 97.1406 57.9453 94.4853 56.8311C91.7239 55.6812 89.8061 54.9672 87.1464 54.0043C82.2228 52.1994 81.0741 51.9315 79.581 51.9123C78.1622 51.8828 76.9759 52.0723 76.193 52.2561C75.4101 52.44 74.4032 52.8307 73.4476 53.5912C71.6748 55.0176 71.1489 56.8742 70.9898 57.5495C70.6906 58.6712 70.7426 59.5935 70.7588 59.8927C70.8313 60.963 71.1209 61.777 71.2499 62.1611C72.9049 66.6297 74.0551 68.0028 73.8857 70.0612C73.8814 70.2125 73.7282 71.8416 72.6246 73.1753C70.3747 75.8988 65.9382 75.0565 59.675 75.0702C56.7947 75.0673 52.5264 75.2568 47.2708 76.161C46.4665 76.3729 44.099 77.1532 42.6226 79.4429C42.02 80.3806 41.807 81.214 41.7207 81.5024C40.5235 85.9893 43.6887 90.6004 48.6271 90.8707L48.5954 90.8249ZM172.588 128.963C176.599 130.015 178.984 134.106 177.921 138.097C176.857 142.088 172.74 144.468 168.73 143.416C164.719 142.364 162.333 138.273 163.397 134.281C164.46 130.29 168.577 127.911 172.563 128.967L172.588 128.963ZM146.189 117.296C146.378 115.562 148.103 113.79 149.902 113.466C152.023 113.096 152.739 114.982 155.602 115.037C158.082 115.071 158.63 113.739 160.564 114.023C162.473 114.311 164.377 116.384 164.376 118.193C164.356 121.336 159.086 124.503 154.428 124.068C150.332 123.681 145.816 120.438 146.189 117.296ZM135.271 136.043C136.335 132.052 140.451 129.673 144.462 130.725C148.473 131.777 150.859 135.868 149.795 139.859C148.732 143.85 144.615 146.23 140.604 145.178C136.593 144.126 134.207 140.035 135.271 136.043Z",
    fill: "#D1D3D4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 39.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 39.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 6.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.5,
    cy: 6.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 39.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 91.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.5,
    cy: 59.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.5,
    cy: 127.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 127.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 82.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 82.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 39.5,
    r: 6.5,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_26935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 135,
    fill: "white",
    transform: "translate(100 66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_759_26935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 18,
    fill: "white",
    transform: "translate(140 110)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.2e350c90fe31dcd5832d4bc42da45d3b.svg";
export { ForwardRef as ReactComponent };